import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

export interface IRouteChild {
  value?: unknown;
  outlet?: string;
}

@Pipe({
  standalone: true,
  name: 'isChildRouteActive',
  pure: false
})
export class IsChildRouteActivePipe implements PipeTransform {
  /**
   * @constructor
   *
   * @param route
   */
  constructor(
    private readonly route: ActivatedRoute
  ) {}

  /**
   * Check if a route or any child route is active.
   *
   * @param input Either a single path string or an array of child route objects.
   * @param outlet Optional outlet name to filter by.
   * @returns True if the route or any child route is active, false otherwise.
   */
  public transform(input: string | IRouteChild[] | null | undefined, outlet?: string): boolean {
    if (!input) {
      return false;
    }

    // Handle single path string without child routes.
    if (typeof input === 'string') {
      return this.isRouteActive(input, outlet);
    }

    // Handle paths for child routes.
    if (Array.isArray(input) && input.length > 0) {
      return input.some(child => {
        const path = child.value?.toString() || '';

        return this.isRouteActive(path, child.outlet);
      });
    }

    return false;
  }

  /**
   * Check if a specific route is active.
   *
   * @param path The route path to check.
   * @param outlet Optional outlet name to filter by.
   * @returns True if the route is active, false otherwise.
   */
  private isRouteActive(path: string, outlet?: string): boolean {
    return this.route.children.some(
      childRoute => (!outlet || outlet === childRoute.outlet) && childRoute.routeConfig?.path === path
    );
  }
}
